export const AvailableLanguages = {
  NORWEGIAN: 'nb',
  ENGLISH: 'en',
  DANISH: 'da'
} as const;

export type AvailableLanguage =
  (typeof AvailableLanguages)[keyof typeof AvailableLanguages];
